import React, {useState} from 'react'
import { supabase } from './SupabaseClient'
import { useRecoilState } from 'recoil'

import { addTaskModalState, selectedPrintData} from '../atoms/add_task_modal'

export default function PrintDataCard({print_data, reload_data}:any) {

  const [modal_open, set_modal_open] = useRecoilState(addTaskModalState)
  const [selected_print_data, set_selected_print_data] = useRecoilState(selectedPrintData)

  const handleDeletePrintData = async () => {
      console.log("delete")
      const { error } = await supabase
        .from('print_data')
        .delete()
        .eq('id', print_data.id)

      await reload_data()
  }

  const handleAddQueueTask = async () => {
    set_selected_print_data(print_data)
    set_modal_open(true)
  }

  return (
    <>
    <div
        id="partnerCard"
        className="bg-white outline outline-offset-2 outline-gray-500/50 text-gray-500 overflow-hidden rounded-md max-w-sm p-2 min-h-[500px] flex flex-col"
    >
      <div>
          <h3 className="text-left pl-8 pb-4 pt-2 text-xl">
              {print_data.name}
          </h3>
      </div>

      <div className="flex items-center justify-center bg-[#2a2a2a] min-h-[200px]">

              <a
                  className="flex items-center justify-center"
                  href="#"
                  target="_blank"
                  rel="noreferrer noopener"
              >
               <img
                      src="https://res.cloudinary.com/easycode/image/upload/v1655738921/Logo/Logo_transparent_vbriwo.png"
                      alt="EasyCode"
                      className="w-1/2 object-cover"
                  />

              </a>
      </div>
      <div className="grid grid-cols-4">
          <div className="p-4 pr-0 text-lg col-span-3">
                  <p>{print_data.note}</p>
          </div>
      </div>

      <div className="mt-auto grid grid-cols-6 gap-y-2">
          <button className="col-start-1 col-span-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">編集</button>
          <button className="col-start-5 col-span-2 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full" onClick={handleDeletePrintData}>削除</button>
          <button className="col-start-1 col-span-6 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full" onClick={handleAddQueueTask}>キューに追加</button>
      </div>
    </div>
    </>

  )

}